import { ExclamationCircleFill } from "react-bootstrap-icons";

interface Props {
  errorMessage?: string;
}

export default function FormFieldError({ errorMessage }: Props) {
  if (!errorMessage) return null;

  return (
    <div className="d-flex lh-sm mt-1 gap-1 align-items-start text-danger">
      <ExclamationCircleFill
        size={14}
        style={{ marginTop: "3px", flexShrink: 0 }}
      />
      {errorMessage}
    </div>
  );
}
